import React from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import Icon from "@mui/material/Icon";
import { motion } from "framer-motion";

const servicesData = [
  {
    color: "primary",
    icon: "apartment",
    title: "Find a House",
    description:
      "Explore available houses and apartments for rent or purchase in East Africa, all in one convenient place.",
  },
  {
    color: "primary",
    icon: "directions_car_filled",
    title: "Find a Car",
    description:
      "Rent or buy reliable vehicles with or without professional drivers. Ideal for daily commutes, business trips, or long-term stays.",
  },
  {
    color: "primary",
    icon: "landscape",
    title: "Find Land",
    description:
      "Explore legally verified land and plots for investment or development. Get guidance on location value, documentation, and future growth.",
  },
  {
    color: "primary",
    icon: "cleaning_services",
    title: "Find a Maid",
    description:
      "Connect with trusted, background-checked housekeepers for cleaning, cooking, or full-time home support—available short or long term.",
  },
  {
    color: "primary",
    icon: "child_friendly",
    title: "Find a Nanny",
    description:
      "Hire experienced and caring nannies to support your family. Choose from live-in or part-time options that fit your schedule.",
  },
  {
    color: "primary",
    icon: "badge",
    title: "Find a Driver",
    description:
      "Get professional, licensed drivers familiar with local routes. Perfect for business, family transport, or personal travel needs.",
  },
];

function ServicesSection() {
  return (
    <MKBox
      component="section"
      py={{ xs: 8, md: 12 }}
      px={{ xs: 2, md: 6 }}
      sx={{
        background: "linear-gradient(180deg, #f8f9fb 0%, #f8f9fb 100%)",
      }}
    >
      {/* Section Title */}
      <MKTypography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        mb={2}
        sx={{ color: "#003060" }}
      >
        Our Services
      </MKTypography>

      <MKTypography
        variant="body1"
        textAlign="center"
        mb={7}
        sx={{ maxWidth: 640, mx: "auto", opacity: 0.8 }}
      >
        Everything you need to settle comfortably and confidently in East Africa.
      </MKTypography>

      <Grid container spacing={4} justifyContent="center">
        {servicesData.map((card, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
            >
              <MKBox
                p={4}
                height="100%"
                display="flex"
                flexDirection="column"
                textAlign="center"
                sx={{
                  background: "rgba(255,255,255,0.75)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "1.75rem",
                  border: "1px solid rgba(0,0,0,0.05)",
                  boxShadow: "0 10px 35px rgba(0,0,0,0.08)",
                  transition: "all 0.4s ease",
                  "&:hover": {
                    transform: "translateY(-12px)",
                    boxShadow: "0 20px 45px rgba(0,0,0,0.15)",
                  },
                }}
              >
                {/* Icon */}
                <MKBox
                  mx="auto"
                  mb={3}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "18px",
                    background: "linear-gradient(135deg, #700808, #9b1c1c)",
                    color: "#fff",
                    fontSize: "2rem",
                    boxShadow: "0 8px 25px rgba(112,8,8,0.35)",
                  }}
                >
                  <Icon>{card.icon}</Icon>
                </MKBox>

                {/* Title */}
                <MKTypography variant="h5" fontWeight="bold" mb={1.5} sx={{ color: "#003060" }}>
                  {card.title}
                </MKTypography>

                {/* Description */}
                <MKTypography variant="body2" sx={{ opacity: 0.8, mb: 3, flexGrow: 1 }}>
                  {card.description}
                </MKTypography>

                {/* CTA Button */}
                <MKButton
                  component={Link}
                  to={`/services/${card.title.toLowerCase().replace(/\s+/g, "-")}`}
                  variant="outlined"
                  sx={{
                    mt: "auto",
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#700808",
                    color: "#700808",
                    px: 4,
                    py: 1,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#700808",
                      color: "#fff",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Learn more
                </MKButton>
              </MKBox>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </MKBox>
  );
}

export default ServicesSection;
